import { useQuery } from 'react-query'

// Libs
import { fetchSiteNav } from '@/api/fetchSiteNav'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// 後台改選單後前台最多 5 分鐘內更新；整份不分語系 / 地區（前台自己挑），頁首頁尾共用同一份快取
const SITE_NAV_CACHE_TIME = 5 * 60 * 1000

/** data 為 undefined（還沒回來或失敗）時，呼叫端改用寫死的預設選單 */
export const useSiteNav = () =>
  useQuery([QUERY_KEY.FETCH_SITE_NAV], fetchSiteNav, {
    staleTime: SITE_NAV_CACHE_TIME,
    cacheTime: SITE_NAV_CACHE_TIME,
    retry: 1,
  })
